import BitmapText from 'core/display/simple/BitmapText'
import { gsap } from 'gsap'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'
import { time } from 'settings/custom/rolling'

export default class FreespinsTotalWinPopupText extends BitmapText{
  constructor(data) {
    super(data)

    this.tween = { value: 0 }

    const freespinModel = game.models.FreespinModel.get()

    signal.on('STATE:IN:FS-END', () => {
      this.update(FormatService.currency(0, false).split('.').join(',') )
      this.animate(freespinModel.totalWin)
    })

    signal.on('STATE:IN:SPIN', this.reset.bind(this))
  }

  onUpdate() {
    const value = FormatService.currency(this.tween.value, false).split('.').join(',')
    super.update(value)
  }

  reset() {
    gsap.killTweensOf(this.tween)
    this.tween.value = 0

    this.onUpdate()
    super.update(0)
  }

  animate(amount) {
    const value = this.tween.value + amount
    const winTween = gsap.to(this.tween, time.endFreeSpinTimeCounter || 3, {
      value, delay: time.delayEndFreeSpin || 1,
      onUpdate: () => {
        this.onUpdate()
      },
      ease: 'Expo.easeOut',
      onComplete: () => {
        winTween.kill()
      },
    })
  }
}
